/* eslint-disable react/require-default-props */
import "focus-visible"
import React from "react"
import {NextThemeProvider, ThemeModel} from "@next/ux-fabric"
import {Theme} from "@mui/material/styles"
import {RealmStyles} from "models/styles"
import HeaderHeightStyles from "./components/HeaderHeightStyles"
import {globalStyle} from "./GlobalStyle"
import {IS_BROWSER} from "./utils/window"
import Header from "./compositions"
import SkipContent from "./components/SkipContent"
import {PLATFORM_MODERNISATION_HEADER, HEADER} from "./config/constants"

interface MyAppProps {
    appScope: string
    uxFabric?: ThemeModel
    styles: RealmStyles
    realm: string
    textAlignment: Theme["direction"]
    themeVersion: string
    themeName: string
    useDevEsi: boolean
    template: string
    widescreenCookieConsent: boolean
    privacyUrl: string
}

export const App: React.FC<MyAppProps> & any = (props: MyAppProps) => {
    const colours = IS_BROWSER()
        ? (window as any).uxFabric[`${props.themeVersion}-${props.realm}-${HEADER}`]
        : props.uxFabric

    return (
        <NextThemeProvider uxfabric={colours} textAlignment={props.textAlignment}>
            <>
                {globalStyle}
                <section id={PLATFORM_MODERNISATION_HEADER} className="x-next-plat-mod" suppressHydrationWarning>
                    <SkipContent />
                    <HeaderHeightStyles />
                    <Header {...props} />
                </section>
            </>
        </NextThemeProvider>
    )
}

export default App
